<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          Cookies aceitos em todas as plataformas da Emulzint
        </div>
      </div>
      <div class="card-body mt-4">
        <div class="row mb-4">
          <div class="col-md-2" align="left">
            <button class="btn btn-add" type="button" @click="collapseToggle">
              <i class="fa fa-filter"></i> Filtros
            </button>
          </div>
          <div class="col-md-2">
            <button class="btn btn-add" type="button" @click="getEntity">
              <i class="fa fa-refresh"></i> Atualizar
            </button>
          </div>
        </div>

        <div class="row mb-3" v-if="collapse == 1">
          <div class="col-md-3 mt-2">
            <label>IP</label>
            <input type="text" v-model="filters.ip" class="form-control" />
          </div>
          <div class="col-md-3 mt-2">
            <label>Módulo</label>
            <select class="form-control" v-model="filters.module">
              <option
                v-for="moduleName in modules"
                :key="moduleName"
                :value="moduleName"
              >
                {{ moduleName }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mt-2">
            <label>Data de Início</label>
            <input
              type="date"
              class="form-control"
              v-model="filters.date_start"
            />
          </div>
          <div class="col-md-3 mt-2">
            <label>Data Final</label>
            <input
              type="date"
              class="form-control"
              v-model="filters.date_end"
            />
          </div>
          <div class="col-md-12 mt-4 mb-3" align="center">
            <button class="btn btn-add" @click="getEntity()">Pesquisar</button>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-12">
            <table
              class="table table-striped table-bordered table-hover"
              style="font-size: 14px"
            >
              <thead>
                <tr>
                  <th>#</th>
                  <th>IP</th>
                  <th>Módulo</th>
                  <th>Cookies Necessários</th>
                  <th>Analytics e Desempenho</th>
                  <th>Propaganda</th>
                  <th>Conteúdo personalizado e mídia social</th>
                  <th>Data/Hora</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="cookie in cookies" :key="cookie.id">
                  <td>{{ cookie.id }}</td>
                  <td>{{ cookie.ip }}</td>
                  <td>{{ cookie.module }}</td>
                  <td>
                    <span
                      :class="
                        cookie.status == 1
                          ? 'badge badge-success'
                          : 'badge badge-danger'
                      "
                      >{{ cookie.status == 1 ? "Ativo" : "Inativo" }}</span
                    >
                  </td>
                  <td>
                    <span
                      :class="
                        cookie.analytics == 1
                          ? 'badge badge-success'
                          : 'badge badge-danger'
                      "
                      >{{ cookie.analytics == 1 ? "Ativo" : "Inativo" }}</span
                    >
                  </td>
                  <td>
                    <span
                      :class="
                        cookie.advertising == 1
                          ? 'badge badge-success'
                          : 'badge badge-danger'
                      "
                      >{{ cookie.advertising == 1 ? "Ativo" : "Inativo" }}</span
                    >
                  </td>
                  <td>
                    <span
                      :class="
                        cookie.content_and_social_media == 1
                          ? 'badge badge-success'
                          : 'badge badge-danger'
                      "
                      >{{
                        cookie.content_and_social_media == 1
                          ? "Ativo"
                          : "Inativo"
                      }}</span
                    >
                  </td>
                  <td>
                    {{ cookie.datetime }}
                  </td>
                </tr>
                <tr v-if="cookies.length == 0">
                  <td colspan="8" align="center">
                    Nenhum registro encontrado.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12">
            <pagination
              :records="total"
              :options="options"
              :per-page="10"
              @paginate="getEntity"
            ></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { Pagination } from "vue-pagination-2";
export default {
  data: function () {
    return {
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      total: 0,
      page: 1,
      collapse: 0,
      cookies: [],
      modules: ["Panefood", "Emulzint Site"],
      filters: {
        status: [0, 1],
      },
      dataModal: null,
      status: [
        {
          id: 0,
          text: "Aguardando",
        },
        {
          id: 1,
          text: "Em andamento",
        },
        {
          id: 2,
          text: "Finalizado",
        },
      ],
    };
  },
  components: { vSelect, Pagination },
  methods: {
    getEntity(page) {
      const self = this;
      self.page = page;
      const api =
        self.$store.state.api + "cookies_accepted/manage?page=" + self.page;

      self.$http
        .post(api, self.filters)
        .then((response) => {
          self.cookies = response.data.data;
          self.total = response.data.total;
          self.$store.commit("updateNotifications");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    collapseToggle() {
      if (this.collapse == 1) {
        this.collapse = 0;
      } else {
        this.collapse = 1;
      }
    },
  },
  mounted() {
    this.getEntity();
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.btn-add {
  border-radius: 0.25rem !important;
  border: 2px solid #4b2e8f !important;
  padding: 6px 10px 4px !important;
  font-weight: 700 !important;
}

.btn-add:hover,
.btn-add:focus {
  background-color: #4b2e8f !important;
  color: #fff !important;
}
.mt-2 {
  margin-top: 1.5rem;
}
.mt-4 {
  margin-top: 1.5rem;
}
.mt-3 {
  margin-top: 1.5rem;
}
.mb-4 {
  margin-top: 1.5rem;
}
.mb-3 {
  margin-top: 1.5rem;
}
.card-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 35px;
}
th {
  vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// src/components/CookiesAccepted/Index.vue